import * as Yup from "yup";
export type deliverySchType = {
  college_ids: string[];
  class_ids: string;
};

export const deliverySchInitialValuesFilter: deliverySchType = {
   college_ids: [],
  class_ids: "",
};

export const deliverySchMandatoryFields = [
];

export const deliverySchValidationSchemaFilter = Yup.object().shape({});

export const deliverySchPropertiesFilter = [
  {
    id: "college_ids",
    type: "multi-select-dependency",
    label: "College",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    isDependent: true,
    options: [],
    list: "college_list_del_sch",
    dependencyLabel: "no college list",
    keyValue: { label: "college_name", value: "college_id" },
    fieldKeyLists: {},
  },
  {
    id: "class_ids",
    type: "single-select-dependency",
    label: "Class *",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    options: [],
    required: true,
    list: "class_list_del_sch",
    keyValue: { label: "class_name", value: "class_id" },
    dependentFields: [""],
    dependentFlds: {
      class_course_batch_data: "class_list_gqf",
    },
  },

];
